<div class="dialog">
  <div class="dialog-header">
    <div class="title">Send / Edit Emails - {{ data.teamName }}</div>
    <button mat-icon-button (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <div class="helper">
    Send emails to selected employees. Accepted employees stay accepted when they are emailed again.
  </div>

  <div class="automation-panel">
    <div class="automation-main">
      <div class="automation-label">Automation</div>
      <div class="automation-summary">{{ automationSummary }}</div>
    </div>

    <mat-form-field appearance="outline" class="automation-date">
      <mat-label>Initial send date</mat-label>
      <input
        matInput
        [matDatepicker]="automationPicker"
        [min]="minAutomationDate"
        [max]="maxAutomationDate"
        [(ngModel)]="automationDate"
        />
      <mat-datepicker-toggle matIconSuffix [for]="automationPicker"></mat-datepicker-toggle>
      <mat-datepicker #automationPicker></mat-datepicker>
    </mat-form-field>

    <button
      mat-stroked-button
      type="button"
      [disabled]="isAutomationSaving || !automation || !automationDate"
      (click)="scheduleAutomation()"
      >
      Schedule
    </button>

    <button
      mat-stroked-button
      color="warn"
      type="button"
      [disabled]="isAutomationSaving || !automation?.enabled"
      (click)="disableAutomation()"
      >
      Disable
    </button>
  </div>

  <div class="filter-card">
    <div class="filter-title">FILTER EMPLOYEE LIST</div>

    <mat-form-field appearance="outline" class="search">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput placeholder="Search employees by name or email..." [(ngModel)]="search" />
    </mat-form-field>

    <div class="filter-row">
      @for (filter of availablePayrollFilters; track trackPayrollFilter($index, filter)) {
        <mat-form-field
          appearance="outline"
          class="filter"
          >
          <mat-select
            class="payroll-filter-select"
            [placeholder]="filter[0]"
            [value]="activeFiltersMap[filter[0]]"
            (selectionChange)="handleFilterSelect(filter[0], $event.value)"
            panelClass="payroll-filter-select-panel"
            multiple
            >
            <mat-select-trigger>
              <span class="filter-trigger">
                <span class="filter-trigger-label">{{ filter[0] }}</span>
                <span class="filter-trigger-count">{{ activeFilterCount(filter[0]) }}</span>
              </span>
            </mat-select-trigger>
            @for (filterOption of filter[1]; track filterOption) {
              <mat-option [value]="filterOption">
                {{ displayFilterValue(filter[0], filterOption) }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-form-field appearance="outline" class="filter status-filter">
        <mat-select
          class="payroll-filter-select"
          [value]="statusFilter"
          (selectionChange)="onStatusFilterChange($event.value)"
          panelClass="payroll-filter-select-panel"
          >
          <mat-select-trigger>
            <span class="filter-trigger">
              <span class="filter-trigger-label">Status</span>
              @if (statusFilter !== 'All Statuses') {
                <span class="filter-trigger-value">
                  {{ statusFilter }}
                </span>
              }
            </span>
          </mat-select-trigger>
          <mat-option [value]="'All Statuses'">All Statuses</mat-option>
          @for (s of allStatuses; track s) {
            <mat-option [value]="s">{{ s }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    @if (activeFilterChips.length) {
      <div class="applied-row">
        <mat-chip-listbox class="chips">
          @for (f of activeFilterChips; track trackActiveFilterChip($index, f)) {
            <mat-chip-option
              selected
              removable
              (removed)="removeActiveFilter(f)"
              >
              <span class="chip-label">{{ f.label }}: {{ f.kind === 'status' ? f.value : displayFilterValue(f.label, f.value) }}</span>
              <button matChipRemove class="chip-x" aria-label="Remove filter">
                <mat-icon>close</mat-icon>
              </button>
            </mat-chip-option>
          }
        </mat-chip-listbox>
        <button mat-button class="clear-all" (click)="clearAllFilters()">Clear all</button>
      </div>
    }
  </div>

  <div class="actions">
    <button
      mat-raised-button
      color="primary"
      class="primary-action"
      (click)="sendInviteNow()"
      [disabled]="isSending"
      >
      <mat-icon class="btn-icon-left">send</mat-icon>
      Send Email Now
    </button>
    <span class="selection-meta">{{ selectedCount }} selected</span>
  </div>

  <div class="table-wrap">
    <table class="invitee-table">
      <thead>
        <tr>
          <th class="check">
            <mat-checkbox
              [checked]="allVisibleSelected"
              [indeterminate]="someVisibleSelected"
              (change)="toggleAllVisible($event.checked)"
            ></mat-checkbox>
          </th>
          <th>Name</th>
          <th>Department</th>
          <th>Location</th>
          <th>Email</th>
          <th>Last Invited</th>
          <th>Last Login</th>
          <th>Status</th>
        </tr>
      </thead>

      <tbody>
        @for (i of filteredInvitees; track i) {
          <tr>
            <td class="check">
              <mat-checkbox
                [checked]="isSelected(i.memberId)"
                [disabled]="!isInviteeSelectable(i)"
                (change)="toggleOne(i.memberId, $event.checked)"
              ></mat-checkbox>
            </td>
            <td class="name">{{ getInviteeName(i) }}</td>
            <td>{{ getInviteeDepartmentDisplay(i) }}</td>
            <td>{{ getInviteeLocationDisplay(i) }}</td>
            <td class="email">{{ i.email }}</td>
            <td>{{ i.inviteSentAt ? (i.inviteSentAt | date : 'short') : '—' }}</td>
            <td>{{ i.dayOfLogin ? (i.dayOfLogin | date : 'shortDate') : '—' }}</td>
            <td>
              <span [class]="getInviteStatusPillClass(getInviteStatus(i))">
                {{ getInviteStatus(i) }}
              </span>
            </td>
          </tr>
        }

        @if (!filteredInvitees.length) {
          <tr>
            <td class="empty" colspan="8">No employees match your filters.</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="footer">
    <div class="footer-note">Any employee shown in this list can be selected for email.</div>
    <button mat-stroked-button (click)="close()">Close</button>
  </div>
</div>
